import { Enterprise } from '../../../types/ProductFactory';
import { Party } from '../../parties/src/types';
import { Prospect } from '../types/apiTypes';

export const mapProspectToCompany = (prospectObj: Prospect): Enterprise => {
  const { prospect } = prospectObj;
  return {
    party_id: prospect.id,
    id: prospect.id,
    email: prospect.email,
    native_language: prospect.native_language as 'NL' | 'EN' | 'FR',
    telephonenr: prospect.telephonenr,
    iban: prospect.iban,
    address: prospect.address,
    name: prospect.name,
    company_registration: prospect.company_registration,
    rsz_nr: prospect.rsz_nr,
    founding_date: prospect.founding_date,
    legal_form: prospect.legal_form,
    commercial_name: prospect.name,
  };
};

export const mapPartyToCompany = (party: Party): Enterprise => {
  return {
    party_id: party.id,
    id: party.id,
    email: party.email,
    native_language: party.native_language as 'NL' | 'EN' | 'FR',
    telephonenr: party.telephonenr,
    iban: party.iban,
    address: party.address,
    name: party.name || '',
    company_registration: party.company_registration,
    rsz_nr: party.rsz_nr,
    founding_date: party.founding_date,
    legal_form: party.legal_form,
    commercial_name: party.name,
  };
};
